import { bindingMode, computedFrom } from "aurelia-binding";
import { autoinject, bindable } from "aurelia-framework";
import { IElement } from "../../../interfaces/form-builder/i-element";

@autoinject
export class ComingSoonSection {
    @bindable({ defaultBindingMode: bindingMode.toView })
    public element: IElement;
}
